export const GLOBAL_STATE = 'AcademicYears'

export const ACADEMIC_YEAR = 'ACADEMIC_YEAR' as const
export const ACADEMIC_YEAR_CREATE = 'ACADEMIC_YEAR_CREATE' as const
export const ACADEMIC_YEAR_DELETE = 'ACADEMIC_YEAR_DELETE' as const
export const ACADEMIC_YEAR_LIST = 'ACADEMIC_YEAR_LIST' as const
export const ACADEMIC_YEAR_ALL = 'ACADEMIC_YEAR_ALL' as const
